import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {getResume3dApi} from '../../API/API'

function* getResume3dSaga(action) {
  try {
    const {id} = action.payload;
    const response = yield call(() => getResume3dApi(id));
    if (response){
          }
    yield put({ type: types.GET_RESUME3D_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_RESUME3D_FAILURE, error });
  }
}

export function* watchGetResume3dSaga() {
  yield takeEvery(types.GET_RESUME3D_REQUESTED, getResume3dSaga);
}
